import { render, staticRenderFns } from "./AdminOpciones.vue?vue&type=template&id=61a7c91a"
import script from "./AdminOpciones.vue?vue&type=script&lang=js"
export * from "./AdminOpciones.vue?vue&type=script&lang=js"
import style0 from "./AdminOpciones.vue?vue&type=style&index=0&id=61a7c91a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports